import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import { Placeholder } from '@adc/ui-core'
import { Cell } from 'fixed-data-table-2'
import classnames from 'classnames/bind'
import DataTableUtils from '../utils'
import styles from '../styles.scss'
const cx = classnames.bind(styles)

class PlaceholderCell extends Component {
  static propTypes = {
    rowIndex: PropTypes.number,
    definition: PropTypes.shape({
      colProps: PropTypes.object.isRequired,
      field: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      formatOptions: PropTypes.shape({
        custom: PropTypes.string,
        customOptions: PropTypes.object,
        titleCase: PropTypes.bool,
      }),
    }).isRequired,
    data: PropTypes.array,
    customFormatters: PropTypes.object,
  }

  state = {
    length: 'full',
  }

  componentDidMount() {
    this.setState({
      length: ['full', 'very long', 'long', 'medium', 'short', 'very short'][
        Math.floor(Math.random() * 6)
      ],
    })
  }

  render() {
    const { rowIndex, definition, ...restProps } = this.props
    const { field } = definition
    const baseField = field.substring(field.lastIndexOf('.') + 1)
    return (
      <Cell
        data-elm-id={`${baseField}_${rowIndex}`}
        className={cx('cell')}
        {..._.omit(restProps, ['data', 'customFormatters'])}
      >
        <div
          style={{
            width: DataTableUtils.getCellInnerWidth(definition.colProps),
          }}
          className={cx('text-truncate')}
        >
          <Placeholder>
            <Placeholder.Paragraph>
              <Placeholder.Line length={this.state.length} />
            </Placeholder.Paragraph>
          </Placeholder>
        </div>
      </Cell>
    )
  }
}

export default PlaceholderCell
